const color = {
  namespaced: true,
  state:{
    isShow:false,
    top:0,
    left:0,
    color_change:Function,
    select_color:'',//纯色的值
    Pattern:'',//pure_color 纯色   linear_gradient 渐变
    linear_gradient:{}


  },
  mutations:{
    isShow_change(state,val){
      state.isShow = val;
    },
    select_color_change(state,val){
      state.select_color = val;
    },
    set_color_change(state,Fn){
      state.color_change = Fn;
    },
    set_Pattern(state,val){
      state.Pattern = val;
    },
    set_linear_gradient(state,val){
      state.linear_gradient = val;
    },
    set_position(state,obj){
      state.top = obj.top;
      state.left = obj.left;
    }

  },
  actions:{

  }

};



export default color;



// WEBPACK FOOTER //
// ./src/vuex/modules/color.js